import { render, staticRenderFns } from "./ViewPurchasesPaymentComponent.vue?vue&type=template&id=6cebe655"
import script from "./ViewPurchasesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./ViewPurchasesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports